import { useMutation } from 'react-query';

import { getBoardTaskInit as mutationFn } from 'api/endPoints/getBoardTaskInit';

export const useMutationGetActivityOptions = () => {
    return useMutation<IGetActivityOptionsResponse[], QueryError, IGetActivityOptionsPayload>((params) =>
        mutationFn(params),
    );
};

interface IGetActivityOptionsPayload {
    wbsId: number;
}

interface IGetActivityOptionsResponse {
    id: number;
    activityId: string;
    name: string;
}
